import { TextFieldProps } from '@mui/material';
import { useState } from 'react';
import './ccf-debouced-input.module.scss';
import { CcfTextField } from '../ccf-textfield/ccf-textfield';

/* eslint-disable-next-line */
export interface CcfDeboucedInputProps {
  delay: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDebounceChange?: (value: string | null) => any;
}

/**
 * Component to provide debounced input
 * @param props - CcfDeboucedInputProps
 * @example <CcfDeboucedInput />
 * @returns debounced input
 */
export function CcfDeboucedInput(
  props: CcfDeboucedInputProps & TextFieldProps
) {
  const { delay, onChange, onDebounceChange, value, ...rest } = props;
  const [debounce, updateDebouncer] = useState<{
    delay: number;
    timer: NodeJS.Timeout | null;
    value: string | null;
  }>({
    delay,
    timer: null,
    value: value as string,
  });

  /**
   * function to update debounced input
   * @param e - HTMLTextAreaElement | HTMLInputElement
   * @example  debouncedUpdate

   */
  function debouncedUpdate(
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) {
    if (debounce.timer) clearTimeout(debounce.timer);
    const timer = setTimeout(() => {
      updateDebouncer((prevState) => {
        if (onChange) onChange(e);
        if (onDebounceChange) onDebounceChange(e.target.value);
        return { ...prevState, value: e.target.value };
      });
    }, debounce.delay);
    updateDebouncer((prevState) => ({
      ...prevState,
      timer,
      value: e.target.value,
    }));
  }

  return (
    <CcfTextField
      id="debouncedinput"
      onChange={debouncedUpdate}
      value={debounce.value}
      sx={{
        '& .MuiOutlinedInput-root': {
          maxHeight: '30px'
        }
      }}
      {...rest}
    />
  );
}

export default CcfDeboucedInput;
